import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RecurringScheduledMaintenanceTaskOccurrencePreview } from '../scheduled-maintenance-recurrence.model';

@Component({
    selector: 'maintenance-schedule-preview',
    templateUrl: './maintenance-schedule-preview.component.html',
    styleUrls: ['./maintenance-schedule-preview.component.less'],
    imports: [DatePipe]
})
export class MaintenanceSchedulePreviewComponent {
    @Input() occurrences: RecurringScheduledMaintenanceTaskOccurrencePreview[] = [];
}
